import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "../../ui/card";

/**
 * SOCreate component - Placeholder for Scheduled Offering creation functionality
 * Future interface for creating new Scheduled Offerings with program selection,
 * date setting, Program Leader assignment, and automatic session generation
 */
export default function SOCreate() {
  return (
    <div className="container mx-auto p-4">
      <Card className="max-w-2xl mx-auto">
        <CardHeader>
          <CardTitle>Create Scheduled Offering</CardTitle>
          <CardDescription>
            Create new Scheduled Offerings with program selection and session generation
          </CardDescription>
        </CardHeader>
        <CardContent>
          <div className="text-center py-8">
            <p className="text-lg text-muted-foreground mb-4">Coming Soon</p>
            <p className="text-sm text-muted-foreground">
              This feature will allow administrators to create new Scheduled Offerings
              by selecting programs, setting dates, assigning Program Leaders, and
              automatically generating sessions.
            </p>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}